import germanI18n from "@emoji-mart/data/i18n/de.json";
import englishI18n from "@emoji-mart/data/i18n/en.json";
import spanishI18n from "@emoji-mart/data/i18n/es.json";

const getI18n = lang => {
  const i18nMap = {
    en: englishI18n,
    de: germanI18n,
    es: spanishI18n,
  };
  return i18nMap[lang] || englishI18n;
};

export default getI18n;
